/**
 * @function init Used to control site arabic version promotion popup
 * @param {Object} params
 * @param {String} params.containerSelector
 * @param {String} params.closeButtonSelector
 * @param {String} params.redirectButtonSelector
 **/
module.exports = function init(params) {
    var _ = require('lodash'),
        defaultOptions = {
            closeButtonSelector: '.js-arabic-promotion-close',
            containerSelector: '.js-arabic-promotion',
            redirectButtonSelector: '.js-arabic-promotion-redirect'
        };

    _.extend(defaultOptions, params);
    
    $(document).ready(function () {
        var $container = $(defaultOptions.containerSelector),
            $closeButton = $container.find(defaultOptions.closeButtonSelector),
            $redirectButton = $container.find(defaultOptions.redirectButtonSelector);

            function detachPopUp() {
                $.get({
                    url: $(this).data('close-url')
                });

                $container.detach();
            }

            function redirectClick() {
                location.href = $(this).data('url');
            }

            $closeButton.bind('click', detachPopUp);
            $redirectButton.bind('click', redirectClick);

        }
    );
}




// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/popup-helper.js